import { gql } from '@apollo/client';

export const GET_WORKSPACE_FORMS_WITH_TEMPLATE = gql`
  query GetWorkspaceFormsWithTemplate($id: ID!) {
    workspaceForms: getWorkspaceForms(id: $id) {
      id
      name
      version
      published
      template {
        id
        jsonData
      }
    }
  }
`;
